import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        showFilters: false
    },
    reducers: {
        toggleFilters: (state) => {
            state.showFilters = !state.showFilters;
        }
    }
});

export const uiActions = uiSlice.actions;
export default uiSlice.reducer;